import DynamicPicture from "@/components/common/DynamicPicture";
import BaseModule from "@/components/site-builder/BaseModule";
import type { HeroModuleType } from "./types";
import { DisplayVariant } from "./constants";
import s from "./HeroModule.module.css";
import HeroVariant2 from "./HeroVariant2";
import HeroVariant3 from "./HeroVariant3";
import HeroVariant4 from "./HeroVariant4";

export interface HeroModuleProps {
  module: HeroModuleType;
}

export default function HeroModule(props: HeroModuleProps) {
  const { module } = props;
  const {
    style: {
      display: { displayVariant },
    },
    body: { image, mediaDisplayVariant },
  } = module;

  if (displayVariant === DisplayVariant.Variant2) {
    return <HeroVariant2 module={module} />; // Background - 50:50
  }

  if (displayVariant === DisplayVariant.Variant3) {
    return <HeroVariant3 module={module} />; // Foreground - 50:50
  }

  if (displayVariant === DisplayVariant.Variant4) {
    return <HeroVariant4 module={module} />; // Image Overlap
  }

  return (
    <BaseModule module={module} className={s.wrapper}>
      <DynamicPicture image={image} option={mediaDisplayVariant} />
    </BaseModule>
  );
}
